var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ColumnTogglerListItem } from './ColumnTogglerListItem';
import { ColumnTogglerColumnItem } from './ColumnTogglerColumnItem';
export var ColumnTogglerGroupItem = function (_a) {
    var group = _a.group, onClick = _a.onClick;
    var allChecked = group.columns.every(function (q) { return !q.hidden; });
    var numberOfChecked = group.columns.filter(function (q) { return !q.hidden; }).length;
    var numberOfUnchecked = group.columns.filter(function (q) { return q.hidden; }).length;
    var isIndeterminate = numberOfChecked > 0 && numberOfUnchecked > 0;
    var handleClickOnGroup = function () {
        if (allChecked) {
            onClick(group.columns.map(function (column) { return (__assign(__assign({}, column), { hidden: true })); }));
        }
        else {
            // if all items are unchecked or at least one is unchecked
            onClick(group.columns.map(function (column) { return (__assign(__assign({}, column), { hidden: false })); }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ColumnTogglerListItem, { checked: allChecked, indeterminate: isIndeterminate, onClick: handleClickOnGroup, label: group.groupName }),
        group.columns.map(function (column, idx) { return React.createElement(ColumnTogglerColumnItem, { column: column, onClick: function (changedColumn) { return onClick([changedColumn]); }, key: idx, className: 'columnToggler__listItem--indented' }); })));
};
//# sourceMappingURL=ColumnTogglerGroupItem.js.map